/**
 * Available event statuses.
 */
export enum EventStatus {
  PREORDERED = 'preordered',
  ORDERED = 'ordered',
  CANCELED = 'canceled',
}

/**
 * Event with details.
 */
export default class Event {
  /**
   * Unique ID.
   */
  public uq_id: string;

  /**
   * Event ID.
   */
  public id: string;

  /**
   * Revision ID.
   */
  public revision_id: string = '';

  /**
   * Room ID.
   */
  public room_id: string = '';

  /**
   * Table number.
   */
  public table_numbers: string = 'all';

  /**
   * Room options.
   */
  public options: Array<{ name: string, amount: string }> | null = null;

  /**
   * Date from, as ISO string.
   */
  public date_from: string | null = null;

  /**
   * Date to, as ISO string.
   */
  public date_to: string | null = null;

  /**
   * Event type.
   */
  public type: string | null = null;

  /**
   * Contacts.
   */
  public contacts: Array<{ name: string, phone: string }> = [];

  /**
   * Client`s comments.
   */
  public client_comments: string | null = null;

  /**
   * Status of event.
   */
  public status: string = EventStatus.ORDERED;

  /**
   * Status cancellation reason.
   */
  public status_cancellation_reason: string | null = null;

  /**
   * Status confirmation date.
   */
  public status_confirmation_date: any | null = null; // TODO: date type

  /**
   * Payments.
   */
  public payments: Array<{ date: string | null, owner: string, amount: string, type: string }> = [{
    date: null,
    owner: '',
    amount: '',
    type: '',
  }];

  /**
   * Refunds.
   */
  public refunds: Array<{ date: string | null, owner: string, amount: string, type: string }> = [{
    date: null,
    owner: '',
    amount: '',
    type: '',
  }];

  /**
   * Persons.
   */
  public persons: Array<{ count: string, price: string }> | null = null;

  /**
   * Manager`s comments.
   */
  public manager_comments: string | null = null;

  /**
   * Attachments.
   */
  public attachments: Array<{ id: string, name: string, mimetype: string, size: string }> = [];

  /**
   * Menu items.
   */
  public menu: Array<{ id: string, title: string }> = [];

  /**
   * Room created date.
   */
  public created_at: any = 'null';


  public fillFromFields (fields: any) {
    // TODO
  }
}
